import {createSlice} from '@reduxjs/toolkit';
import {createSupplier} from "../../api/supplier/create";

export const addSupplierSlice = createSlice({
    name: 'suppliers/add',
    initialState: {
        request: false,
        messageTitle: '',
        message: '',
        outcome: 'pending',
    },
    reducers: {
        showError(state, action) {
            state.request = false;
            state.outcome = 'fail';
            state.messageTitle = action.payload.title;
            state.message = action.payload.message;
        },
        showSuccess(state, action) {
            state.request = false;
            state.outcome = 'success';
            state.messageTitle = action.payload.title;
            state.message = action.payload.message;
        },
        cancelError(state) {
            state.request = false;
            state.outcome = 'pending';
            state.message = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(createSupplier.pending, (state, action) => {
                state.request = true;
            })
            .addCase(createSupplier.fulfilled, (state, action) => {
                state.request = false;
                state.outcome = 'success';
                state.message = '';
            })
            .addCase(createSupplier.rejected, (state, action) => {
                const { payload } = action;
                state.request = false;
                state.outcome = 'fail';
                state.messageTitle = 'Error';
                //@ts-ignore
                state.message = payload.message;
            })
    },
});

export const { cancelError, showError, showSuccess } = addSupplierSlice.actions

export default addSupplierSlice.reducer;